module.exports = __webpack_public_path__ + "static/bluebooties-c549844544dfc57613e236ae5cfc7b4b.png";